module.exports = __webpack_public_path__ + "img/_Generic15.b6168071.jpg";